var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaying(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FED241"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 13.6838C20.4312 13.5871 21 14.0755 21 14.714V25.5H19.8V13.6838Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25.5C13 23.2909 14.7909 21.5 17 21.5C19.2091 21.5 21 23.2909 21 25.5C21 27.7091 19.2091 29.5 17 29.5C14.7909 29.5 13 27.7091 13 25.5Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8392 15.3656L19.8 16.4294V13.3381C19.8 12.3651 20.5206 11.5333 21.5071 11.3674L26.6386 10.5045C26.853 10.4685 27.0375 10.6536 26.9935 10.8608L26.0865 15.131C26.061 15.2509 25.9632 15.3437 25.8392 15.3656Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaying);
export default __webpack_public_path__ + "static/media/playing.2680a65f9f40c3efef34fb452877ee35.svg";
export { ForwardRef as ReactComponent };